
import Hero from './components/Hero'
import Problem from './components/Problem'
import Solution from './components/Solution'
import Credibility from './components/Credibility'
import FOMO from './components/FOMO'
import Benefits from './components/Benefits'
import SignUp from './components/SignUp'
import FAQ from './components/FAQ'
import FinalCTA from './components/FinalCTA'
import Footer from './components/Footer'

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Hero />
      <Problem />
      <Solution />
      <Credibility />
      <FOMO />
      <Benefits />
      <SignUp />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  )
}

export default App
